export type Port = {
  id: string
  x: number // 0..1 of SVG width
  y: number // 0..1 of SVG height
  type: 'source' | 'target' | 'both'
  angle?: 0 | 90 | 180 | 270
  label?: string
}

export type SvgTemplate = {
  id: string
  name: string
  svg: string // raw SVG string
  viewBox: { width: number; height: number }
  ports: Port[]
}
